import { isRemote } from '../env';
import { LocalOperationTimesRepository } from './localRepository';
import { RemoteOperationTimesRepository } from './remoteRepository';
import { IOperationTimesRepository } from './IOperationTimesRepository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: IOperationTimesRepository | null = null;

/** Factory: decide en tiempo de arranque que implementacion usar (local vs remote). */
export function getOperationTimesRepository(getToken?: () => Promise<string | null>): IOperationTimesRepository {
  if (!instance) {
    instance = isRemote ? new RemoteOperationTimesRepository(getToken ?? getAuthToken) : new LocalOperationTimesRepository();
  }
  return instance;
}
